import type { TFunction } from 'i18next';

import {
  BonusAttributeField,
  type Lootbox,
  LootboxBonusType,
  LootboxStage,
} from '@/api/common';

export const getMockLootBox = (t: TFunction<'wheel'>): Lootbox => ({
  id: 15,
  title: 'Lootbox TEST',
  stage: LootboxStage.Activated,
  strategy: 'lootbox_item',
  createdAt: '2023-07-20T12:56:22.076Z',
  validUntil: '2023-08-03T12:56:21.846Z',
  display: 1,
  items: [
    {
      weight: 23,
      prize: false,
      createdAt: '2023-07-20T12:56:22.081Z',
      bonuses: [
        {
          title: t('FS', { amount: 10 }),
          type: LootboxBonusType.Freespins,
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 10,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 127,
    },
    {
      weight: 17,
      prize: false,
      createdAt: '2023-07-20T12:56:22.086Z',
      bonuses: [
        {
          title: t('FS', { amount: 15 }),
          type: LootboxBonusType.Freespins,
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 15,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 128,
    },
    {
      weight: 13,
      prize: false,
      createdAt: '2023-07-20T12:56:22.090Z',
      bonuses: [
        {
          title: t('FS', { amount: 25 }),
          type: LootboxBonusType.Freespins,
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 25,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 129,
    },
    {
      weight: 20,
      prize: false,
      createdAt: '2023-07-20T12:56:22.102Z',
      bonuses: [
        {
          title: t('FS', { amount: 35 }),
          type: LootboxBonusType.Bonus,
          attributes: [
            {
              field: BonusAttributeField.BonusAmount,
              value: [
                {
                  currency: 'EUR',
                  amountCents: 500,
                },
                {
                  currency: 'USD',
                  amountCents: 500,
                },
                {
                  currency: 'CAD',
                  amountCents: 500,
                },
                {
                  currency: 'AUD',
                  amountCents: 500,
                },
                {
                  currency: 'NZD',
                  amountCents: 500,
                },
                {
                  currency: 'NOK',
                  amountCents: 5000,
                },
                {
                  currency: 'BTC',
                  amountCents: 20_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 5_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 3_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 6_500_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 8_000_000_000,
                },
              ],
            },
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 132,
    },
    {
      weight: 8,
      prize: false,
      createdAt: '2023-07-20T12:56:22.094Z',
      bonuses: [
        {
          title: t('FS', { amount: 50 }),
          type: LootboxBonusType.Freespins,
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 50,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 130,
    },
    {
      weight: 11,
      prize: false,
      createdAt: '2023-07-20T12:56:22.104Z',
      bonuses: [
        {
          title: t('FS', { amount: 75 }),
          type: LootboxBonusType.Bonus,
          attributes: [
            {
              field: BonusAttributeField.BonusAmount,
              value: [
                {
                  currency: 'EUR',
                  amountCents: 1000,
                },
                {
                  currency: 'USD',
                  amountCents: 1000,
                },
                {
                  currency: 'CAD',
                  amountCents: 1000,
                },
                {
                  currency: 'AUD',
                  amountCents: 1000,
                },
                {
                  currency: 'NZD',
                  amountCents: 1000,
                },
                {
                  currency: 'NOK',
                  amountCents: 10_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 40_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 10_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 6_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 15_000_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 15_000_000_000,
                },
              ],
            },
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 133,
    },
    {
      weight: 2,
      prize: false,
      createdAt: '2023-07-20T12:56:22.098Z',
      bonuses: [
        {
          title: t('FS', { amount: 100 }),
          type: LootboxBonusType.Freespins,
          attributes: [
            {
              field: BonusAttributeField.FreespinsCount,
              value: 100,
            },
            {
              field: BonusAttributeField.FreespinsMaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
          resultBonus: [
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 131,
    },
    {
      weight: 5,
      prize: false,
      createdAt: '2023-07-20T12:56:22.107Z',
      bonuses: [
        {
          title: t('FS', { amount: 125 }),
          type: LootboxBonusType.Bonus,
          attributes: [
            {
              field: BonusAttributeField.BonusAmount,
              value: [
                {
                  currency: 'EUR',
                  amountCents: 5000,
                },
                {
                  currency: 'USD',
                  amountCents: 5000,
                },
                {
                  currency: 'CAD',
                  amountCents: 5000,
                },
                {
                  currency: 'AUD',
                  amountCents: 5000,
                },
                {
                  currency: 'NZD',
                  amountCents: 5000,
                },
                {
                  currency: 'NOK',
                  amountCents: 50_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 200_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 50_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 30_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 65_000_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 80_000_000_000,
                },
              ],
            },
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 134,
    },
    {
      weight: 1,
      prize: false,
      createdAt: '2023-07-20T12:56:22.109Z',
      bonuses: [
        {
          title: t('FS', { amount: 150 }),
          type: LootboxBonusType.Bonus,
          attributes: [
            {
              field: BonusAttributeField.BonusAmount,
              value: [
                {
                  currency: 'EUR',
                  amountCents: 10_000,
                },
                {
                  currency: 'USD',
                  amountCents: 10_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 10_000,
                },
                {
                  currency: 'AUD',
                  amountCents: 10_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 10_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 100_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 400_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 100_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 60_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 125_000_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 150_000_000_000,
                },
              ],
            },
            {
              field: BonusAttributeField.Wager,
              value: 35,
            },
            {
              field: BonusAttributeField.MaxWin,
              value: [
                {
                  currency: 'AUD',
                  amountCents: 30_000,
                },
                {
                  currency: 'CAD',
                  amountCents: 30_000,
                },
                {
                  currency: 'EUR',
                  amountCents: 30_000,
                },
                {
                  currency: 'USD',
                  amountCents: 30_000,
                },
                {
                  currency: 'NOK',
                  amountCents: 300_000,
                },
                {
                  currency: 'NZD',
                  amountCents: 30_000,
                },
                {
                  currency: 'BCH',
                  amountCents: 300_000_000,
                },
                {
                  currency: 'BTC',
                  amountCents: 1_200_000,
                },
                {
                  currency: 'DOG',
                  amountCents: 500_000_000_000,
                },
                {
                  currency: 'ETH',
                  amountCents: 180_000_000,
                },
                {
                  currency: 'LTC',
                  amountCents: 400_000_000,
                },
              ],
            },
          ],
        },
      ],
      id: 135,
    },
  ],
  groupKey: 'manual_lootbox_bonus1',
});
